export type MediaType = "movie" | "tv";

export interface Title {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  language: string;
  duration: string;
  episodes?: string;
  rating: number;
  heat: number;
  summary: string;
  poster: string;
}

export const titles: Title[] = [
  {
    id: "wu-gang-mi-cheng",
    title: "雾港迷城",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["犯罪", "悬疑"],
    director: "陈牧",
    cast: ["段奕辰", "周婉", "韦振邦"],
    language: "普通话",
    duration: "118 分钟",
    rating: 8.6,
    heat: 9862,
    summary:
      "一座常年被海雾笼罩的港口小城，接连出现三起毫无关联的失踪案。退休刑警陆铮被迫重返一线，在潮水与谎言之间，一点点拼出被掩埋了十二年的真相。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20thriller%20poster%20art%2C%20a%20lone%20detective%20in%20a%20long%20coat%20standing%20on%20a%20foggy%20harbour%20dock%20at%20night%20with%20cargo%20cranes%20silhouetted%20behind%20him%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-wugang-01&orientation=portrait",
  },
  {
    id: "chang-an-jiu-shi",
    title: "长安旧事",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["古装", "剧情"],
    director: "顾行之",
    cast: ["商临", "苏婉清", "韩雪"],
    language: "普通话",
    duration: "132 分钟",
    rating: 8.9,
    heat: 8720,
    summary:
      "天宝年间的长安城，一名掌管文书的小吏意外得到半卷残破的户籍册。为了替素不相识的百姓讨回姓名，他走进了一场无人愿意触碰的旧案。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20film%20poster%20art%2C%20an%20ancient%20Changan%20palace%20courtyard%20at%20dusk%20with%20a%20scholar%20in%20Tang%20dynasty%20robes%20holding%20a%20paper%20lantern%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-changan-02&orientation=portrait",
  },
  {
    id: "shan-hai-zhi-jian",
    title: "山海之间",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    director: "林知远",
    cast: ["沈砚", "许青禾", "何万山"],
    language: "普通话",
    duration: "108 分钟",
    rating: 8.2,
    heat: 5417,
    summary:
      "在外打拼十五年的女儿回到海边小镇，才发现父亲早已认不出她。一条修了三年也没修完的环海公路，成了父女俩重新认识彼此的唯一通道。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20poster%20art%2C%20a%20father%20and%20daughter%20walking%20along%20a%20misty%20mountain%20coastal%20road%20with%20distant%20fishing%20boats%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shanhai-03&orientation=portrait",
  },
  {
    id: "ji-ye-zhui-xiong",
    title: "极夜追凶",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "动作"],
    director: "郑耀东",
    cast: ["韦振邦", "梁以宁", "秦牧之"],
    language: "粤语 / 普通话",
    duration: "121 分钟",
    rating: 8.0,
    heat: 7628,
    summary:
      "台风登陆前的最后一夜，重案组督察与一名即将退休的卧底在霓虹与雨水之间完成最后一次交接，而他们要抓的人，就站在警队之中。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20action%20crime%20poster%20art%2C%20a%20rain%20soaked%20street%20at%20midnight%20with%20two%20figures%20facing%20each%20other%20under%20neon%20signs%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-jiye-04&orientation=portrait",
  },
  {
    id: "di-qi-ge-xia-tian",
    title: "第七个夏天",
    type: "movie",
    year: 2022,
    region: "中国台湾",
    genres: ["爱情", "剧情"],
    director: "蔡以安",
    cast: ["林书晴", "江承宇"],
    language: "普通话",
    duration: "104 分钟",
    rating: 8.4,
    heat: 4236,
    summary:
      "毕业那年的夏天，他们在海边约定每年见一面。七年过去，海堤修好了，渡轮换了新漆，只有那句没说出口的话还停在原地。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Taiwan%20romance%20film%20poster%20art%2C%20a%20young%20couple%20on%20a%20sunlit%20seaside%20pier%20with%20bicycles%20and%20drifting%20clouds%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-xiatian-05&orientation=portrait",
  },
  {
    id: "shan-he-gu-ren-wei-yuan",
    title: "山河故人未远",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["战争", "历史"],
    director: "韩慕白",
    cast: ["秦牧之", "韩雪", "王大勇"],
    language: "普通话",
    duration: "146 分钟",
    rating: 9.1,
    heat: 6314,
    summary:
      "一支负责护送电台的七人小队，在雪线上与队伍失联。他们并不知道，自己护送的频率，是整条防线唯一的希望。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20war%20epic%20poster%20art%2C%20a%20wartime%20mountain%20pass%20with%20soldiers%20marching%20through%20drifting%20snow%20and%20a%20distant%20burning%20village%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shanhe-06&orientation=portrait",
  },
  {
    id: "wu-sheng-xue-yuan",
    title: "无声雪原",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "惊悚"],
    director: "江砚",
    cast: ["段奕辰", "苗青"],
    language: "普通话",
    duration: "112 分钟",
    rating: 7.9,
    heat: 5932,
    summary:
      "林场护林员的日志停在去年十二月。一支调查组进驻雪原后，才发现这片林子里每一棵被做过记号的树，都对应着一个失踪的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20mystery%20thriller%20poster%20art%2C%20a%20snow%20covered%20pine%20forest%20with%20a%20single%20figure%20in%20a%20red%20scarf%20and%20a%20small%20wooden%20cabin%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-xueyuan-07&orientation=portrait",
  },
  {
    id: "gui-tu-lie-che-xiang-bei",
    title: "归途列车向北",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "公路"],
    director: "邹平原",
    cast: ["王大勇", "周婉"],
    language: "普通话",
    duration: "98 分钟",
    rating: 8.3,
    heat: 3125,
    summary:
      "春运最后一班慢车，一位农民工揣着一张中奖的彩票，只想在年三十前赶回老家。车厢里挤满了和他一样急着回去的人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20road%20drama%20poster%20art%2C%20an%20old%20green%20train%20crossing%20a%20vast%20northern%20wheat%20field%20at%20golden%20hour%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-guitu-08&orientation=portrait",
  },
  {
    id: "xing-hai-shi-meng",
    title: "星海拾梦",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["科幻", "剧情"],
    director: "陆星河",
    cast: ["沈砚", "程未", "苏婉清"],
    language: "普通话",
    duration: "126 分钟",
    rating: 8.7,
    heat: 9143,
    summary:
      "深空站失控前十分钟，值夜工程师收到一条来自地球的语音，发件人是二十年前的自己。为了救回整支船队，他必须先学会放弃。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20science%20fiction%20poster%20art%2C%20an%20astronaut%20floating%20above%20a%20glowing%20blue%20planet%20with%20a%20space%20station%20silhouette%20in%20the%20distance%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-xinghai-09&orientation=portrait",
  },
  {
    id: "yi-wan-ren-jian",
    title: "一碗人间",
    type: "movie",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情", "美食"],
    director: "高满堂",
    cast: ["何万山", "许青禾"],
    language: "普通话",
    duration: "105 分钟",
    rating: 8.5,
    heat: 3874,
    summary:
      "小巷深处的面馆要拆了。老板把最后一锅汤熬了整整一夜，来送行的老客们点上同一碗面，也各自讲完了一段没说完的故事。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20food%20drama%20poster%20art%2C%20a%20steaming%20bowl%20of%20beef%20noodles%20on%20a%20wooden%20table%20in%20a%20warm%20small%20alley%20kitchen%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-yiwan-10&orientation=portrait",
  },
  {
    id: "jiang-hu-ye-yu-shi-nian-deng",
    title: "江湖夜雨十年灯",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["武侠", "古装"],
    director: "顾行之",
    cast: ["商临", "苗青", "秦牧之"],
    language: "普通话",
    duration: "138 分钟",
    rating: 8.8,
    heat: 7056,
    summary:
      "十年前的一场大火烧掉了一座门派，也烧掉了一个人的名字。十年后，他带着一盏旧灯回到故地，只为等一个人赴约。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20wuxia%20film%20poster%20art%2C%20a%20swordsman%20in%20flowing%20robes%20standing%20in%20heavy%20rain%20beside%20a%20lantern%20lit%20temple%20gate%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-jianghu-11&orientation=portrait",
  },
  {
    id: "shi-yu-zhe",
    title: "失语者",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "心理"],
    director: "江砚",
    cast: ["周婉", "韦振邦", "苗青"],
    language: "普通话",
    duration: "116 分钟",
    rating: 8.1,
    heat: 4869,
    summary:
      "心理咨询师接诊了一位从不说话的来访者。三个月后她发现，对方描述的每一段记忆，都与她自己的童年严丝合缝。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20psychological%20thriller%20poster%20art%2C%20a%20woman%20standing%20in%20a%20dim%20hallway%20of%20mirrors%20with%20fractured%20reflections%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shiyu-12&orientation=portrait",
  },
  {
    id: "chun-chao-wan-lai",
    title: "春潮晚来",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    director: "林知远",
    cast: ["许青禾", "韩雪", "何万山"],
    language: "普通话",
    duration: "96 分钟",
    rating: 8.0,
    heat: 2548,
    summary:
      "外婆把老屋的院子种满了桃树，说等花开的时候，离家最久的那个人就会回来。这一年春天，花开了两遍。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20poster%20art%2C%20an%20elderly%20woman%20and%20a%20young%20girl%20tending%20spring%20blossoms%20in%20a%20riverside%20courtyard%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-chunchao-13&orientation=portrait",
  },
  {
    id: "tie-xue-li-ming",
    title: "铁血黎明",
    type: "movie",
    year: 2020,
    region: "中国大陆",
    genres: ["战争", "动作"],
    director: "韩慕白",
    cast: ["秦牧之", "王大勇"],
    language: "普通话",
    duration: "134 分钟",
    rating: 8.2,
    heat: 4187,
    summary:
      "黎明前的最后四十分钟，一支残部必须守住山口。他们没有炮，没有援军，只有一条不能后退的命令。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20war%20action%20poster%20art%2C%20soldiers%20silhouetted%20against%20a%20burning%20dawn%20sky%20on%20a%20ruined%20battlefield%20ridge%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-tiexue-14&orientation=portrait",
  },
  {
    id: "chang-ye-jiang-ming",
    title: "长夜将明",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "刑侦"],
    director: "江砚",
    cast: ["段奕辰", "周婉", "苗青"],
    language: "普通话",
    duration: "45 分钟 / 集",
    episodes: "全 24 集",
    rating: 9.0,
    heat: 12486,
    summary:
      "连续七年，同一座城市在同一个雨夜发生同一种案件。新上任的痕迹检验师发现，所有卷宗里都缺了同一张现场照片。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20series%20poster%20art%2C%20a%20forensic%20investigator%20examining%20evidence%20under%20cold%20light%20in%20a%20rainy%20city%20alley%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-changye-15&orientation=portrait",
  },
  {
    id: "da-zhai-men-li",
    title: "大宅门里",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["年代", "家族"],
    director: "顾行之",
    cast: ["商临", "韩雪", "苏婉清"],
    language: "普通话",
    duration: "42 分钟 / 集",
    episodes: "全 36 集",
    rating: 8.7,
    heat: 8763,
    summary:
      "药铺起家的百年宅门，在时代浪潮里迎来最难的十年。三个房头、两代女人和一本不敢翻开的账册，撑起了一座院子最后的体面。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20period%20family%20drama%20poster%20art%2C%20a%20grand%20republican%20era%20mansion%20courtyard%20with%20hanging%20lanterns%20and%20carved%20wooden%20gates%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-dazhai-16&orientation=portrait",
  },
  {
    id: "qing-yun-zhi-shang",
    title: "青云之上",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["仙侠", "古装"],
    director: "陆星河",
    cast: ["沈砚", "苏婉清", "程未"],
    language: "普通话",
    duration: "40 分钟 / 集",
    episodes: "全 40 集",
    rating: 8.3,
    heat: 10247,
    summary:
      "被逐出师门的小弟子在青云海畔捡到一柄断剑，剑中封着一位不记得自己姓名的上神。两人的相遇，改写了整座仙门的命数。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20xianxia%20series%20poster%20art%2C%20a%20young%20immortal%20standing%20on%20a%20floating%20mountain%20peak%20above%20a%20sea%20of%20clouds%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-qingyun-17&orientation=portrait",
  },
  {
    id: "wo-men-de-shi-nian",
    title: "我们的十年",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["都市", "情感"],
    director: "林知远",
    cast: ["许青禾", "江承宇", "林书晴"],
    language: "普通话",
    duration: "41 分钟 / 集",
    episodes: "全 32 集",
    rating: 8.5,
    heat: 6328,
    summary:
      "四个从同一栋筒子楼走出来的年轻人，用十年时间散落在四座城市。当年的天台约定，最后只剩下一个人还在按时赴约。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20urban%20drama%20poster%20art%2C%20four%20friends%20sitting%20on%20a%20rooftop%20at%20sunset%20overlooking%20a%20modern%20city%20skyline%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shinian-18&orientation=portrait",
  },
  {
    id: "mi-wu-ma-tou",
    title: "迷雾码头",
    type: "tv",
    year: 2025,
    region: "中国香港",
    genres: ["犯罪", "悬疑"],
    director: "郑耀东",
    cast: ["韦振邦", "梁以宁", "秦牧之"],
    language: "粤语 / 普通话",
    duration: "43 分钟 / 集",
    episodes: "全 20 集",
    rating: 8.8,
    heat: 9317,
    summary:
      "一个集装箱在码头静静停了十七天，里面的东西让整个缉私队集体沉默。当所有人都在说谎时，只有潮汐记录着真实的时间。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20crime%20series%20poster%20art%2C%20a%20container%20port%20at%20night%20with%20police%20car%20lights%20cutting%20through%20thick%20fog%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-miwu-19&orientation=portrait",
  },
  {
    id: "zhui-guang-zhe",
    title: "追光者",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "励志"],
    director: "邹平原",
    cast: ["程未", "林书晴", "王大勇"],
    language: "普通话",
    duration: "38 分钟 / 集",
    episodes: "全 28 集",
    rating: 8.1,
    heat: 5214,
    summary:
      "省队落选之后，短跑少年回到县城的煤渣跑道。没有教练、没有计时器，只有一群同样不肯认输的人陪他跑到天亮。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20youth%20sports%20drama%20poster%20art%2C%20young%20runners%20on%20a%20track%20at%20dawn%20with%20long%20shadows%20and%20lens%20flare%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-zhuiguang-20&orientation=portrait",
  },
  {
    id: "ren-jian-yan-huo-xiao-guan",
    title: "人间烟火小馆",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["治愈", "美食"],
    director: "高满堂",
    cast: ["何万山", "苗青", "许青禾"],
    language: "普通话",
    duration: "36 分钟 / 集",
    episodes: "全 24 集",
    rating: 8.9,
    heat: 4482,
    summary:
      "巷口的小馆只做六道菜，每晚只接待七桌客人。老板娘说，菜是给胃的，故事是给心的，两样都不能少。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20healing%20food%20series%20poster%20art%2C%20a%20cozy%20street%20side%20restaurant%20at%20night%20with%20warm%20hanging%20bulbs%20and%20steaming%20dishes%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-yanhuo-21&orientation=portrait",
  },
  {
    id: "shan-he-tie-jun",
    title: "山河铁军",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["战争", "历史"],
    director: "韩慕白",
    cast: ["秦牧之", "王大勇", "韩雪"],
    language: "普通话",
    duration: "45 分钟 / 集",
    episodes: "全 30 集",
    rating: 9.2,
    heat: 7136,
    summary:
      "从鸭绿江到冰河，一支工兵连用三年时间在炮火里修出一条条通路。他们没有击落过一架飞机，却让整支部队走过了最冷的那条江。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20war%20history%20series%20poster%20art%2C%20a%20column%20of%20soldiers%20crossing%20a%20frozen%20river%20under%20a%20pale%20winter%20sky%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-tiejun-22&orientation=portrait",
  },
  {
    id: "shuang-mian-hua-xiang",
    title: "双面画像",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "心理"],
    director: "江砚",
    cast: ["周婉", "苗青", "段奕辰"],
    language: "普通话",
    duration: "39 分钟 / 集",
    episodes: "全 18 集",
    rating: 8.4,
    heat: 6841,
    summary:
      "画室里的两幅肖像，一幅画着死者，一幅画着凶手。画家坚持说自己从未见过他们中的任何一个人。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20mystery%20series%20poster%20art%2C%20a%20portrait%20painter%20studio%20with%20two%20facing%20canvases%20and%20a%20shadowy%20figure%20between%20them%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shuangmian-23&orientation=portrait",
  },
  {
    id: "jin-xiu-yi-guan",
    title: "锦绣医馆",
    type: "tv",
    year: 2022,
    region: "中国大陆",
    genres: ["古装", "爱情"],
    director: "蔡以安",
    cast: ["苏婉清", "商临", "何万山"],
    language: "普通话",
    duration: "42 分钟 / 集",
    episodes: "全 36 集",
    rating: 8.0,
    heat: 3927,
    summary:
      "江南小镇的女医师接下了一家濒临倒闭的医馆，也接下了一桩牵扯三代人的旧方子。药能医人，方子却能要命。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20medical%20drama%20poster%20art%2C%20an%20ancient%20herbal%20medicine%20shop%20with%20rows%20of%20drawers%20and%20a%20young%20female%20physician%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-yiguan-24&orientation=portrait",
  },
  {
    id: "ye-hang-xing",
    title: "夜航行",
    type: "tv",
    year: 2024,
    region: "中国台湾",
    genres: ["悬疑", "奇幻"],
    director: "蔡以安",
    cast: ["林书晴", "江承宇", "梁以宁"],
    language: "普通话",
    duration: "44 分钟 / 集",
    episodes: "全 16 集",
    rating: 7.8,
    heat: 2863,
    summary:
      "一艘只在午夜启航的渡轮，载着七位不肯说出目的的乘客。船靠岸时，总有人没能下船。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Taiwan%20mystery%20series%20poster%20art%2C%20a%20small%20ferry%20boat%20drifting%20on%20a%20dark%20ocean%20under%20a%20huge%20starry%20sky%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-yehang-25&orientation=portrait",
  },
  {
    id: "xiao-man-de-chun-tian",
    title: "小满的春天",
    type: "tv",
    year: 2021,
    region: "中国大陆",
    genres: ["家庭", "农村"],
    director: "林知远",
    cast: ["许青禾", "何万山", "苗青"],
    language: "普通话",
    duration: "37 分钟 / 集",
    episodes: "全 30 集",
    rating: 8.6,
    heat: 3413,
    summary:
      "十二岁的小满在村小撤并那年学会了骑车，每天往返十六里路。她说等油菜花开满整条路，妈妈就会回来。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20rural%20family%20series%20poster%20art%2C%20a%20village%20field%20of%20yellow%20rapeseed%20flowers%20with%20a%20girl%20riding%20a%20bicycle%20on%20a%20dirt%20road%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-xiaoman-26&orientation=portrait",
  },
  {
    id: "bai-zhou-yan-huo",
    title: "白昼焰火",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["犯罪", "剧情"],
    director: "陈牧",
    cast: ["段奕辰", "梁以宁", "苗青"],
    language: "普通话",
    duration: "114 分钟",
    rating: 8.4,
    heat: 6214,
    summary:
      "白天放烟火的人，往往在庆祝一件不能说的事。一名即将调离的刑警，用最后三天时间盯住了一场看似普通的婚礼。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20drama%20poster%20art%2C%20pale%20daylight%20smoke%20from%20fireworks%20drifting%20over%20an%20old%20city%20rooftop%20with%20a%20solitary%20man%20in%20a%20suit%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-baizhou-27&orientation=portrait",
  },
  {
    id: "xun-shan-ji",
    title: "寻山记",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["冒险", "剧情"],
    director: "邹平原",
    cast: ["何万山", "程未", "韩雪"],
    language: "普通话",
    duration: "122 分钟",
    rating: 8.3,
    heat: 4761,
    summary:
      "一位老测绘员带着孙子重走三十年前未完成的山路。地图上的最后一个坐标，藏着他一直没有说出口的遗憾。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20adventure%20drama%20poster%20art%2C%20an%20old%20surveyor%20and%20a%20boy%20climbing%20a%20rocky%20mountain%20ridge%20through%20drifting%20clouds%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-xunshan-28&orientation=portrait",
  },
  {
    id: "chao-xi-zhi-yue",
    title: "潮汐之约",
    type: "movie",
    year: 2023,
    region: "中国台湾",
    genres: ["爱情", "奇幻"],
    director: "蔡以安",
    cast: ["林书晴", "江承宇"],
    language: "普通话",
    duration: "101 分钟",
    rating: 7.9,
    heat: 3186,
    summary:
      "渔村的老人说，退潮时走过礁石的人能见到想念的人。她在每个月的十五都去走一次，走了整整四年。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Taiwan%20romantic%20fantasy%20poster%20art%2C%20a%20young%20woman%20walking%20across%20wet%20reef%20stones%20at%20low%20tide%20under%20a%20violet%20grey%20twilight%20sky%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-chaoxi-29&orientation=portrait",
  },
  {
    id: "shen-xiang-deng-huo",
    title: "深巷灯火",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "悬疑"],
    director: "高满堂",
    cast: ["何万山", "周婉", "王大勇"],
    language: "普通话",
    duration: "107 分钟",
    rating: 8.2,
    heat: 3652,
    summary:
      "老城区改造前最后一个冬天，巷子里的灯一盏盏熄灭。修锁匠却在这时收到一把没有主人的钥匙。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20neighborhood%20mystery%20poster%20art%2C%20a%20narrow%20old%20alley%20at%20night%20with%20warm%20hanging%20lamps%20and%20a%20locksmith%20shop%20window%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-shenxiang-30&orientation=portrait",
  },
  {
    id: "po-xiao-zhi-qian",
    title: "破晓之前",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    director: "郑耀东",
    cast: ["韦振邦", "秦牧之", "梁以宁"],
    language: "粤语 / 普通话",
    duration: "119 分钟",
    rating: 8.1,
    heat: 5893,
    summary:
      "天亮前必须把证人送进法院，而通往法院的每一条路都被人提前买断。四个人的车队，只剩下一个方向。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20action%20thriller%20poster%20art%2C%20a%20black%20sedan%20speeding%20through%20an%20empty%20city%20tunnel%20before%20dawn%20with%20headlight%20streaks%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-poxiao-31&orientation=portrait",
  },
  {
    id: "zai-jian-jiu-shi-guang",
    title: "再见旧时光",
    type: "movie",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "青春"],
    director: "林知远",
    cast: ["许青禾", "江承宇", "程未"],
    language: "普通话",
    duration: "99 分钟",
    rating: 8.0,
    heat: 2764,
    summary:
      "母校要拆了，当年的班长在群里发了最后一条通知。三十七个人回来了九个，他们在教室里坐到天黑。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20nostalgic%20youth%20poster%20art%2C%20an%20empty%20high%20school%20classroom%20at%20dusk%20with%20sunlight%20through%20dusty%20windows%20and%20wooden%20desks%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-jiushiguang-32&orientation=portrait",
  },
  {
    id: "long-men-ke-zhan-wai",
    title: "龙门客栈外",
    type: "movie",
    year: 2020,
    region: "中国大陆",
    genres: ["武侠", "动作"],
    director: "顾行之",
    cast: ["商临", "苗青", "王大勇"],
    language: "普通话",
    duration: "128 分钟",
    rating: 8.5,
    heat: 4528,
    summary:
      "客栈外三里，是通往关外的最后一段官道。一个女人、一封密信和十七个不肯说出姓名的刀客，在这里等一场风沙。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20wuxia%20film%20poster%20art%2C%20a%20desert%20road%20outside%20a%20wooden%20inn%20with%20windblown%20sand%20and%20a%20hooded%20swordswoman%20facing%20distant%20riders%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-longmen-33&orientation=portrait",
  },
  {
    id: "yun-duan-lai-xin",
    title: "云端来信",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["科幻", "爱情"],
    director: "陆星河",
    cast: ["沈砚", "林书晴", "苏婉清"],
    language: "普通话",
    duration: "117 分钟",
    rating: 8.6,
    heat: 6748,
    summary:
      "气象站的自动系统开始给一个不存在的地址寄信。值守的年轻人拆开第一封时，落款写着他自己的名字和三年后的日期。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20science%20fiction%20romance%20poster%20art%2C%20a%20weather%20station%20on%20a%20high%20plateau%20with%20layered%20clouds%20and%20a%20single%20glowing%20window%2C%20moody%20deep%20navy%20and%20warm%20amber%20lighting%2C%20atmospheric%20film%20grain%2C%20tall%20portrait%20framing%2C%20no%20text&width=600&height=800&seq=poster-yunduan-34&orientation=portrait",
  },
];

export const getTitleById = (id: string): Title | undefined =>
  titles.find((item) => item.id === id);

export const movieTitles = titles.filter((item) => item.type === "movie");
export const tvTitles = titles.filter((item) => item.type === "tv");